export function tryParseInt(input: any, radix?: number): number {
    let retValue = null;
    if (input !== null) {
        if (input.length > 0) {
            if (!isNaN(input)) {
                retValue = parseInt(input, radix);
            }
        }
    }
    return retValue;
}



// WEBPACK FOOTER //
// ./src/app/utils/try-parse.ts